import React from 'react';
import { Button } from '@mui/material';

import FabButton from "@components/input/buttons/FabButton";

interface Props extends React.ComponentPropsWithoutRef<'div'> {
  disabled?: boolean;
  label?: string;
  label_separate?: boolean;
  fab?: boolean;
  no_fab?: boolean;
  link_url?: string;
  icon?: React.ReactNode;
  log_it?: boolean;
  onClick: (event: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLDivElement> | undefined) => void;
  onMouseDown?: (event: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLDivElement>) => void;
}

export default function BaseButton(props: Props) {
  const label = props.label ? props.label : "";
  const disabled = props.disabled;
  const onClick = props.onClick;
  const link_url = props.link_url;
  const no_fab = props.no_fab;
  const fab = no_fab === undefined ? props.fab : !no_fab;
  const icon = props.icon;
  const onMouseDown = props.onMouseDown;
  const style = props.style;
  const log_it = props.log_it;
  let className = props.className ? props.className : "";
  className += " clickable";
  
  const pass_along_props = {...props};
  delete pass_along_props.label;
  delete pass_along_props.disabled;
  delete pass_along_props.link_url;
  delete pass_along_props.fab;
  delete pass_along_props.no_fab;
  delete pass_along_props.icon;
  delete pass_along_props.style;
  delete pass_along_props.log_it;
  delete pass_along_props.className;

  const renderContent = () => {
    if (log_it) {
      debugger;
    }
    if (icon) {
      if (label === "") {
        if (fab) {
          return (
            <FabButton
              disabled={disabled} 
              onClick={() => { 
                if (!link_url) {
                  onClick(undefined); 
                }
              }}>
              { icon }
            </FabButton>
          );
        } else if (disabled) {
          return (
            <span className="gray">
              { icon }
            </span>
          );
        } else {
          return icon;
        }
      } else {
        return (
          <Button 
            className={className}
            disabled={disabled} 
            variant="contained" color="primary">
            { icon }&nbsp;{ label }
          </Button>
        );
      }
    }
    return null;
  }

  if (disabled) {
    className += " gray";
  }

  if (link_url) {
    return (
      <div {...pass_along_props} className={className} style={style}>
        <a href={link_url} 
          onMouseDown={(event: React.MouseEvent<HTMLAnchorElement>) => {
            if (log_it) {
              console.log(event);
            }
            if (!disabled && onMouseDown) {
              onMouseDown(event);
            }
          }}
          onClick={(event: React.MouseEvent<HTMLAnchorElement>) => {
            event.preventDefault();
            if (log_it) {
              console.log(event);
            }
            if (event.ctrlKey || event.metaKey || event.shiftKey || event.button === 1) {
              return;
            }
            if (log_it) {
              console.log(event);
            }
            if (!disabled && onClick) {
              onClick(event);
            }
            return false;
          }}>
          { renderContent() }
        </a>
      </div>
    );
  } else {
    return (
      <div {...pass_along_props} className={className} style={style}
        onMouseDown={(event: React.MouseEvent<HTMLDivElement>) => {
          if (!disabled && onMouseDown) {
            onMouseDown(event);
          }
        }}
        onClick={(event: React.MouseEvent<HTMLDivElement>) => {
          if (!disabled && onClick && (!icon || !label || !fab)) {
            onClick(event);
          }
        }}>
        { renderContent() }
      </div>
    );
  }
}
